<template>
  <div :class="['mod-code-button', whiteTheme ? 'white-theme':'' ]">
    <button v-if="isFirst && !isCountdown" class="code-button" type="button" @click="onGetCode(true)">获取验证码</button>
    <span v-if="isCountdown" class="code-button count-down">{{ time }}s</span>
    <button v-if="!isFirst && !isCountdown" class="code-button get-again" type="button" @click="onGetCode(false)">重新获取</button>
  </div>
</template>

<script>
export default {
  props: {
    whiteTheme: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      isFirst: true,
      isCountdown: false,
      time: 60
    }
  },
  methods: {
    onGetCode (isFirst) {
      this.$emit('change', () => {
        isFirst && (this.isFirst = false)
        this.countdowm()
      })
    },
    countdowm () {
      this.isCountdown = true
      const timer = setInterval(() => {
        this.time--
        if (this.time === 0) {
          clearInterval(timer)
          this.isCountdown = false
          this.time = 60
        }
      }, 1000)
    }
  }
}
</script>

<style lang="less">
.mod-code-button{
  .code-button{
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid #dcdfe6;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: .1s;
    font-weight: 500;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    padding: 12px 0;
    font-size: 14px;
    border-radius: 4px;
    border-color: transparent;
    color: #409eff;
    background: transparent;
    width: 72px;
    &.get-again{
      color: #cc7a45;
    }
    &.count-down{
      color: #333;
    }
  }
  &.white-theme{
    .code-button{
      color: #fff;
      &.get-again{
        color: #debba5;
      }
      &.count-down{
        color: #fff;
      }
    }
  }
}
</style>
